import { memo } from 'react';
import { IconProps } from './iconType';

export const CloseBgIcon = memo(({ size, color, color2 }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 16 17" fill="none">
      <g clipPath="url(#clip0_1238_2996)">
        <path
          d="M16 8.5C16 10.6217 15.1571 12.6566 13.6569 14.1569C12.1566 15.6571 10.1217 16.5 8 16.5C5.87827 16.5 3.84344 15.6571 2.34315 14.1569C0.842855 12.6566 0 10.6217 0 8.5C0 6.37827 0.842855 4.34344 2.34315 2.84315C3.84344 1.34285 5.87827 0.5 8 0.5C10.1217 0.5 12.1566 1.34285 13.6569 2.84315C15.1571 4.34344 16 6.37827 16 8.5ZM5.354 5.146C5.26011 5.05211 5.13278 4.99937 5 4.99937C4.86722 4.99937 4.73989 5.05211 4.646 5.146C4.55211 5.23989 4.49937 5.36722 4.49937 5.5C4.49937 5.63278 4.55211 5.76011 4.646 5.854L7.293 8.5L4.646 11.146C4.59951 11.1925 4.56264 11.2477 4.53748 11.3084C4.51232 11.3692 4.49937 11.4343 4.49937 11.5C4.49937 11.5657 4.51232 11.6308 4.53748 11.6916C4.56264 11.7523 4.59951 11.8075 4.646 11.854C4.73989 11.9479 4.86722 12.0006 5 12.0006C5.06574 12.0006 5.13084 11.9877 5.19158 11.9625C5.25232 11.9374 5.30751 11.9005 5.354 11.854L8 9.207L10.646 11.854C10.6925 11.9005 10.7477 11.9374 10.8084 11.9625C10.8692 11.9877 10.9343 12.0006 11 12.0006C11.0657 12.0006 11.1308 11.9877 11.1916 11.9625C11.2523 11.9374 11.3075 11.9005 11.354 11.854C11.4005 11.8075 11.4374 11.7523 11.4625 11.6916C11.4877 11.6308 11.5006 11.5657 11.5006 11.5C11.5006 11.4343 11.4877 11.3692 11.4625 11.3084C11.4374 11.2477 11.4005 11.1925 11.354 11.146L8.707 8.5L11.354 5.854C11.4005 5.80751 11.4374 5.75232 11.4625 5.69158C11.4877 5.63084 11.5006 5.56574 11.5006 5.5C11.5006 5.43426 11.4877 5.36916 11.4625 5.30842C11.4374 5.24768 11.4005 5.19249 11.354 5.146C11.3075 5.09951 11.2523 5.06264 11.1916 5.03748C11.1308 5.01232 11.0657 4.99937 11 4.99937C10.9343 4.99937 10.8692 5.01232 10.8084 5.03748C10.7477 5.06264 10.6925 5.09951 10.646 5.146L8 7.793L5.354 5.146Z"
          fill={color2}
        />
      </g>
      <defs>
        <clipPath id="clip0_1238_2996">
          <rect
            width={size}
            height={size}
            fill={color}
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
});

CloseBgIcon.displayName = 'CloseBgIcon';
